module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-imgSolutions.254f01eb.png";